import { render, staticRenderFns } from "./MasterPFA.vue?vue&type=template&id=c8420af2&scoped=true&"
import script from "./MasterPFA.vue?vue&type=script&lang=js&"
export * from "./MasterPFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8420af2",
  null
  
)

export default component.exports